import { render, staticRenderFns } from "./WhatsAppClient.vue?vue&type=template&id=66b58ce0&scoped=true"
import script from "./WhatsAppClient.vue?vue&type=script&lang=js"
export * from "./WhatsAppClient.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppClient.vue?vue&type=style&index=0&id=66b58ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b58ce0",
  null
  
)

export default component.exports